import { useTranslation } from 'react-i18next'

import { FormikForm } from '../../../../Formik'
import { LoginFormBody } from '../../LoginFormBody'
import { LoginFormPhoneNumberFields } from '../LoginFormPhoneNumberFields'

import { LOGIN_FORM_PHONE_NUMBER_INITIAL_VALUES } from './LoginFormPhoneNumber.constants'
import { getLoginFormPhoneNumberValidationSchema } from './LoginFormPhoneNumber.utils'

function LoginFormPhoneNumber({
  getValidationSchema = getLoginFormPhoneNumberValidationSchema,
  initialValues = LOGIN_FORM_PHONE_NUMBER_INITIAL_VALUES,
  isLoading,
  onRemoveNotification,
  onSetNotification,
  onSubmit,
}) {
  const { t } = useTranslation()

  const validationSchema = getValidationSchema()

  return (
    <FormikForm
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      <LoginFormBody
        actionsProps={{
          isLoading,
          submitText: t('Auth.SignInByPhoneSubmitBtnKey'),
        }}
        helpText={t('Auth.SignInByPhoneTextKey')}
        onRemoveNotification={onRemoveNotification}
        onSetNotification={onSetNotification}
      >
        <LoginFormPhoneNumberFields
          isLoading={isLoading}
          onRemoveNotification={onRemoveNotification}
          onSetNotification={onSetNotification}
        />
      </LoginFormBody>
    </FormikForm>
  )
}

export default LoginFormPhoneNumber
